/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['agm-map[_ngcontent-%COMP%] {\n  height: 300px; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvdXNlcnMvdXNlci91c2VyLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0Q6L2luZXRwdWIvd3d3cm9vdC9rYWl6ZW4tbmcvc3JjL2FwcC9tb2R1bGVzL2VtcGxveWVlL3BhZ2VzL3VzZXJzL3VzZXIvdXNlci5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/modules/employee/pages/users/user/user.component.scss.shim.ngstyle.ts